import { QueryObserverResult } from 'react-query'
import { CARRIER_FONT_HANDWRITTEN, CARRIER_FONT_STANDARD } from '@/src/modules/build-a-card/constants'
import { CUSTOM_CARD_IMAGE } from '../constants'
import { ICart, IDelivery, IEmptyCart, ILineItem } from '@/src/modules/cart/ICart'
import { MEDIUM_TYPE_PHYSICAL } from '@/prisma/schemaConstants'

export const createCartObjectFromApiResponse = (
    response: QueryObserverResult
): ICart | IEmptyCart => {
    if (!response.data) {
        return { 
            cart_contents: { deliveries: [] },
        } as IEmptyCart
    }
    return { ...(response.data as ICart) }
}
 
export function handleCustomizationData(setNameOnCard: Function, setMessageOnCard: Function, setFontSelection: Function, setShowHandwrittenModal:Function, lineItem: any) {
    if (lineItem.customization_data) {
        const {
            name_on_card = '',
            message_on_card = '',
            is_handwritten = false,
        } = lineItem.customization_data
        setNameOnCard(name_on_card)
        setMessageOnCard(message_on_card)
        setFontSelection(
            is_handwritten
                ? CARRIER_FONT_HANDWRITTEN
                : CARRIER_FONT_STANDARD
        )
        setShowHandwrittenModal(!is_handwritten)
        return lineItem.customization_data 
    }
}
  
export function getDesignImage(lineItem: ILineItem, setPredesignUuid: any, setDesignImage: any, setDesignName: any, setCustomDesignObject: any) {
    if (lineItem.design?.design_uuid) {
        setPredesignUuid(lineItem.design.design_uuid)
        setDesignImage(
            lineItem.design.resolved_data?.design_preview_url
        )
        setDesignName(lineItem.design.resolved_data?.design_name)
    }
    if (lineItem.custom_design?.url) {
        setCustomDesignObject(lineItem.custom_design)
        setDesignImage(lineItem.custom_design.url)
        setDesignName(CUSTOM_CARD_IMAGE)
    }
    return lineItem.custom_design?.url ?? lineItem.design?.design_uuid
}

export function findDeliveryByLineItemUuid(
    cartData: ICart,
    lineItemUuidToEdit: string | string[]
) {
    if (!lineItemUuidToEdit) {
        return
    }
    // find the Delivery that contains the LineItem.
    return cartData.cart_contents?.deliveries?.find((delivery) =>
        delivery.line_items?.find(
            (li) => li.line_item_uuid === lineItemUuidToEdit
        )
    )
}
export function findLineItemByLineItemUuid(
    delivery: IDelivery,
    lineItemUuidToEdit: string | string[]
) {
    return delivery.line_items?.find(
        (li) => li.line_item_uuid === lineItemUuidToEdit
    )
}
export function findDeliveryByBoxUuid(
    cartData: ICart,
    boxItemUuidToEdit: string | string[]
) {
    return cartData?.cart_contents?.deliveries?.find((delivery) =>
        delivery?.line_items?.find(
            (item) => item?.customization_data?.box_uuid === boxItemUuidToEdit
        )
    )
}
export function findItemsInABox(
    cartData: ICart,
    boxItemUuidToEdit: string | string[]
) {
    return cartData?.cart_contents?.deliveries?.flatMap((delivery) =>
        delivery?.line_items?.filter((item) => {
            return item?.customization_data?.box_uuid === boxItemUuidToEdit
        })
    )
}
export function checkIfExistingDeliveryForPlastic(deliveries: IDelivery[]) {
    return deliveries.findIndex((delivery) =>
        delivery.line_items.find((item) => {
            return (
                item?.product?.resolved_data?.product_medium?.medium_type ===
                MEDIUM_TYPE_PHYSICAL
            )
        })
    )
}
export function checkIfMultiplePlasticDeliveriesExist(deliveries: IDelivery[]) {
    return (
        deliveries.filter((delivery) =>
            delivery.line_items.every((lineItem) => {
                return (
                    lineItem.product?.resolved_data?.product_medium
                        .medium_type === MEDIUM_TYPE_PHYSICAL
                )
            })
        ).length > 1
    )
}
